import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import { Dialog, DialogContentHeadless } from 'v5/design-system/Dialog';
import { MountElementProps } from 'v5/messages/mount-element';
import { WithServices } from 'v5/platform/ts/services';
import { WithEnterpriseService } from 'v5/services/io/EnterpriseService/EnterpriseService';
import {
  TransferToTeamDialogContent,
  type TransferToTeamDialogContentProps
} from './TransferToTeamDialogContent';

export type TransferToTeamDialogProps = MountElementProps &
  WithServices<[WithEnterpriseService]> &
  Pick<
    TransferToTeamDialogContentProps,
    | 'organizationId'
    | 'currentWorkspaceId'
    | 'currentTeamId'
    | 'onSubmit'
    | 'titleMessage'
    | 'descriptionMessage'
    | 'fieldWorkspaceMessage'
    | 'fieldTeamMessage'
  >;

export function TransferToTeamDialog({
  open,
  onOpenChange,
  organizationId,
  currentWorkspaceId = null,
  currentTeamId = null,
  onSubmit,
  services,
  titleMessage,
  descriptionMessage,
  fieldWorkspaceMessage,
  fieldTeamMessage
}: TransferToTeamDialogProps) {
  return (
    <UnsavedChangesProtection
      open={open}
      onOpenChange={onOpenChange}
      beforeUnloadMessage="You have unsaved changes!"
    >
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogContentHeadless className="max-w-120">
            <TransferToTeamDialogContent
              open={dialogProps.open}
              organizationId={organizationId}
              currentWorkspaceId={currentWorkspaceId}
              currentTeamId={currentTeamId}
              onSubmit={onSubmit}
              services={services}
              titleMessage={titleMessage}
              descriptionMessage={descriptionMessage}
              fieldWorkspaceMessage={fieldWorkspaceMessage}
              fieldTeamMessage={fieldTeamMessage}
            />
          </DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
}
